import { NavLink } from 'react-router-dom';

export const Button = ({ children, onClick, className }) => {
  return (
    <button onClick={onClick} className={className}>
      {children}
    </button>
  );
};

export const YellowButton = ({ children, onClick }) => {
  return (
    <button
      type="submit"
      onClick={onClick}
      className=" group relative inline-flex items-center overflow-hidden rounded-[20px] bg-[var(--yellow-primary)]  border-bg-[var(--yellow-primary)]  w-full mx-auto  md:px-12 py-2 text-lg font-medium text-black  hover:bg[#facc15]"
    >
      <span className="relative transform duration-700 hover:bg[#facc15] mx-auto font-medium text-base">
        {children}
      </span>
    </button>
  );
};

export const CheckoutDeliveryAddressButton = ({ children, onClick }) => {
  return (
    <button
      type="submit"
      onClick={onClick}
      className=" group relative inline-flex items-center overflow-hidden rounded-[20px] bg-[var(--yellow-primary)]  border-2 border-bg-[var(--yellow-primary)]  w-full md:w-[30%] mx-auto   py-2 text-lg font-medium text-black hover:bg-gray-50 hover:text-black"
    >
      <span className="duration-400 ease absolute left-0 top-1/2 block h-0 w-full bg-white opacity-100 transition-all group-hover:top-0 group-hover:h-full hover:border-bg-[var(--yellow-primary)] "></span>

      <span className="relative transform duration-700 group-hover:-translate-x-1 mx-auto font-medium text-base">
        {children}
      </span>
    </button>
  );
};

export const CustomButton = ({
  text,
  bgColor = 'var(--yellow-primary)',
  hoverColor = 'var(--btn-hover-bg-primary)',
  width = '40%',
  fontWeight = '600',
  textSize = '1rem',
  borderRadius = '0.5rem',
  type = 'button',
  form,
  onClick,
  disabled,
  className = '',
  textColor = '#000',
  style = {},
}) => {
  const buttonStyles = {
    backgroundColor: disabled ? '#DEDEDE' : bgColor,
    color: disabled ? '#fff' : textColor,
    fontWeight,
    fontSize: textSize,
    borderRadius,
    ...style,
  };

  // map width prop to tailwind class
  const widthClass =
    width === '40%'
      ? 'md:w-[40%]'
      : width === '60%'
        ? 'md:w-[60%]'
        : 'md:w-full';

  return (
    <button
      type={type}
      form={form}
      onClick={onClick}
      disabled={disabled}
      style={buttonStyles}
      className={`w-full ${widthClass}  text-${textColor} py-[6px] px-4 transition-colors duration-300 font-duplet whitespace-nowrap ${
        disabled ? 'opacity-50 cursor-not-allowed' : ''
      } ${className}`}
      onMouseOver={(e) => {
        if (!disabled) e.target.style.backgroundColor = hoverColor;
      }}
      onMouseOut={(e) => {
        if (!disabled) e.target.style.backgroundColor = bgColor;
      }}
    >
      {text}
    </button>
  );
};

export const CustomButtonWithIcon = ({
  text,
  icon,
  icon1,
  link,
  onClick,
  className = '',
  color = '#000',
  width = 'w-fit',
  bgColor = 'var(--yellow-primary)',
  hoverColor = 'var(--btn-hover-bg-primary)',
  borderRadius = '',
}) => {
  const buttonStyles = {
    backgroundColor: bgColor,
    color,
  };

  const buttonContent = (
    <button
      style={buttonStyles}
      className={`flex items-center space-x-3 md:justify-between ${width} py-3 px-6 rounded-[7px] transition-colors duration-300 ${className}`}
      onMouseOver={(e) => (e.currentTarget.style.backgroundColor = hoverColor)}
      onMouseOut={(e) => (e.currentTarget.style.backgroundColor = bgColor)}
      onClick={onClick}
    >
      {icon1 && (
        <div className="flex items-center">
          <img src={icon1} alt="icon" className="w-6 h-6" />
        </div>
      )}
      <span className="font-semibold">{text}</span>
      {icon && (
        <div className="flex items-center">
          <img src={icon} alt="icon" className="w-6 h-6" />
        </div>
      )}
    </button>
  );

  return link ? <NavLink to={link}>{buttonContent}</NavLink> : buttonContent;
};

export const StayActionButton = ({
  active,
  onClick,
  children,
  underline = false,
  ariaLabel = '',
  checkedIn,
  disabled,
}) => (
  <button
    className={`p-1 px-6 rounded-[30px] text-sm lg:text-base border  whitespace-nowrap flex justify-center
  ${active ? 'border-black text-black bg-[#f7f7f7]' : ''}
  ${underline ? 'underline' : ''}
  ${checkedIn || disabled ? ' text-[#D1CECE] bg-[#F2F2F2] cursor-not-allowed border-none' : ''}
`}
    disabled={checkedIn || disabled}
    onClick={onClick}
    aria-label={ariaLabel}
  >
    {children}
  </button>
);
